module.exports = __webpack_public_path__ + "img/whole-home-wifi-sdk.7b7743a.png";